import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { usePostHog } from "posthog-js/react";
import { FallbackProps } from "react-error-boundary";
import { SecondaryButton, translate } from "@shape/reef-shared";
import { Container } from "./styled";
import { recordReactError } from "@shape/otel";

const GenericErrorPage: React.FC<FallbackProps> = ({
  error,
  resetErrorBoundary,
}: FallbackProps) => {
  const navigate = useNavigate();
  const posthog = usePostHog();

  useEffect(() => {
    const properties = {
      message: error.message || "Unknown error",
      stack: error.stack || "No stack trace",
      name: error.name || "UnknownError",
      app_version: __APP_VERSION__,
      env: import.meta.env.VITE_ENVIRONMENT,
      error_category: "APP_CRASH",
    };

    recordReactError(error, { componentStack: "GenericErrorPage" });
    posthog?.captureException(error, properties);
  }, [error, posthog]);

  return (
    <Container>
      <FontAwesomeIcon icon={faTimesCircle} size="6x" />
      <h2>{translate("errorPage.title")}</h2>
      <div>{translate("errorPage.genericErrorText")}</div>
      <SecondaryButton
        onClick={() => {
          resetErrorBoundary();
          navigate("/");
        }}
      >
        {translate("navigation.goTo", { field: translate("home") })}
      </SecondaryButton>
    </Container>
  );
};

export default GenericErrorPage;
